/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, Text, KeyboardAvoidingView, Image, View, StatusBar, StyleSheet, Platform } from 'react-native'
//import HTMLView from 'react-native-htmlview';
import { connect } from 'react-redux'
//import SafariView from '../Lib/SafariView/'

import BaseScreen from './BaseScreen'
import CustomMainNavBar from '../Components/CustomMainNavBar'
import TextComponent from '../Components/TextComponent'
import { isShoppableItemId, isURL, alertView } from '../Lib/utils';
import ItemActions from '../Redux/ItemRedux';
import ShoppableActions from '../Redux/ShoppableRedux';
import styles from './Styles/ProductDescriptionScreenStyle'
import { Images, Fonts } from '../Themes'
import I18n from "i18n-js"

class ProductDescriptionScreen extends Component {
  constructor(args) {
    super(args)
    const { navigation: { state: { params: { item } } } } = this.props
    const itemId = typeof item != 'undefined' && typeof item.ItemId != 'undefined' ? item.ItemId : ''
    const isShoppable = isShoppableItemId(itemId)
    this.state = {
      isShoppable: isShoppable,
      isISell: typeof item.isISell != 'undefined' && item.isISell,
      item: item,
      shoppableItemLoaded: false,
      itemId: itemId,
      shoppableItemId: isShoppable ? itemId.substr(0, itemId.length - 5) : null,
      merchants: null,
      merchantDetail: null,
      merchantName: '',
      returnsUrl: null,
    }
    this.state.isShopify = !this.state.isShoppable && !this.state.isISell
    console.tron.display({ name: `constructor`, preview: `ProductDescriptionScreen`, value: { item: item, state: this.state } })
    if (Platform.OS != 'web')
    this.dismissSubscription = SafariView.addEventListener(
      "onDismiss",
      () => {
        StatusBar.setHidden(false)
        StatusBar.setBarStyle("default", true);
      }
    )
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this)
  }

  back = () => {
    if (this.props.navigation) {
      this.props.navigation.goBack();
    }
  }

  componentWillReceiveProps(nextProps) {
    console.tron.display({ name: `componentWillReceiveProps`, preview: `ProductDescriptionScreen`, value: { nextProps: nextProps } })
    const { shoppableConfig, shoppableItems } = nextProps
    if (this.state.isShoppable) {
      let stateChanges = {}
      if (this.state.merchants == null && !shoppableConfig.fetching && shoppableConfig.data && shoppableConfig.data.merchants && shoppableConfig.data.merchants.length)
        stateChanges.merchants = shoppableConfig.data.merchants
      if (!shoppableItems.fetching && shoppableItems.list.length > 0 && shoppableItems.list[0].ItemId == this.state.itemId) {
        stateChanges.shoppableItemLoaded = true
        stateChanges.item = shoppableItems.list[0]
      }
      if (Object.keys(stateChanges).length > 0) {
        const newState = Object.assign({}, this.state, stateChanges)
        if (newState.merchants && newState.shoppableItemLoaded) {
          const itemMerchantId = newState.item.Shoppable.MerchantId
          for (let i = 0; i < newState.merchants.length; i++) {
            if (newState.merchants[i].id == itemMerchantId) {
              stateChanges.merchantDetail = newState.merchants[i]
              stateChanges.merchantName = stateChanges.merchantDetail.name
              if (stateChanges.merchantDetail.returnsUrl) {
                stateChanges.returnsUrl = stateChanges.merchantDetail.returnsUrl
              }
            }
          }
        }
        this.setState(stateChanges)
      }
    }
    else if (!this.state.isISell && nextProps.item && this.state.itemId == nextProps.item.ItemId) {
      console.tron.log(`componentWillReceiveProps loaded item`)
      this.setState({item: nextProps.item})
    }
  }

  componentDidMount() {
    const { navigation: { state: { params: { item, isFromOrder = false } } } } = this.props
    console.tron.display({
      name: `ProductDescriptionScreen`,
      preview: `componentDidMount`,
      value: {
        state: this.state
      }
    })

    if (this.state.isShoppable) {
      this.props.shoppableGetConfig() // normally will return very quickly...
      this.props.shoppableReadItems([this.state.shoppableItemId])
    }
    else if (!this.state.isISell)
      this.props.readItem({ item: this.state.item })
  }
  
  componentWillUnmount() {
    if (Platform.OS != 'web')
    this.dismissSubscription.remove()
  }

  viewReturnPolicy() {
    const url = this.state.returnsUrl
    if (isURL(url) && Platform.OS != 'web') {
      SafariView.openUrl(url)
    } else if (isURL(url) && Platform.OS == 'web') {
      window.location = url
    }
    else {
      alertView('Invalid URL', 'url')
    }
  }

  render() {
    const item = this.state.item
    const fetching = false // this.props.fetching
    const itemImageUrl = item && (typeof item.ImageUrls != 'undefined') && item.ImageUrls.length ? item.ImageUrls[0] : item && (typeof item.ThumbUrls != 'undefined') && item.ThumbUrls.length ? item.ThumbUrls[0] : null
    const hasReturnPolicyText = item != null && typeof item.StoreReturnPolicy != 'undefined' && item.StoreReturnPolicy != null && typeof item.StoreReturnPolicy.Policy != 'undefined' && item.StoreReturnPolicy.Policy.trim().length != 0
    const returnPolicyText = hasReturnPolicyText ? item.StoreReturnPolicy.Policy.replace(new RegExp(`return policy`, "i"), '').trim() : ''
    return (
      <BaseScreen
        loading={fetching}
        darkStatusbar
      >
        <CustomMainNavBar
          leftButtonTitle={'back'}
          onLeftPress={this.back}
          rightButtonTitle={``}
          title={I18n.t("explora.productDescription")}
        />
        <ScrollView style={styles.container} contentContainerStyle={{ backgroundColor: '#FFFFFF', padding: 10 }}>
          <TextComponent text={!!item && item.Title} style={styles.headerText} />
          <View style={styles.rowDirection}>
            <TextComponent text={I18n.t("explora.brand") + ` : `} style={styles.normalText} />
            <TextComponent text={!!item && item.Brand} style={styles.boldText} />
          </View>
          <View style={styles.rowDirection}>
            <TextComponent text={I18n.t("explora.store") + ` : `} style={styles.normalText} />
            <TextComponent text={!!item && item.StoreName} style={styles.boldText} />
          </View>

          {!!item && <View style={styles.html}>
            {this.state.isShopify && item.Description.length > 0 && <Text value={item.Description} stylesheet={stylesHtml}>{item.Description}</Text>}
            {(this.state.isShoppable || this.state.isISell) && item.Description.length > 0 && <Text>{item.Description}</Text>}
          </View>}

          {!!item && itemImageUrl && <Image resizeMode = 'contain' style={[styles.image, {marginBottom: 20}]} source={{uri :  itemImageUrl}} /> }

          <TextComponent text={'Return Policy'} style={styles.headerText} />
          {!!item && item.StoreReturnPolicy && !hasReturnPolicyText && <View style={styles.rowDirection}>
            <Image style={styles.imageOnline} source={Images.online} />
            <Text style={{ flexWrap: "wrap",}}>
              <TextComponent
                text={`Purchases can be returned within ` + " "}
                style={styles.normalText} />
              {!!item && <TextComponent
                text={item.StoreReturnPolicy.Days + " "}
                style={styles.boldText} /> }
              <TextComponent
                text={` days of purchase.`}

                style={styles.normalText} />
            </Text>
          </View> }
          {!!item && this.state.returnsUrl == null && item.StoreReturnPolicy && <View>
            {!hasReturnPolicyText && <View style={styles.rowDirection}>
              <Image style={styles.imageOnline} source={Images.online} />
              <TextComponent
              numberOfLines = {0}
                text={`The merchant wil be happy to assist you with your return shipping.`}
                style={[styles.normalText,{marginRight: 5}]} />
            </View>}
            <TextComponent
              text={!!item && returnPolicyText}
              style={[styles.normalText]} /> 
          </View>}
          {!!item && this.state.returnsUrl &&
            <Text style={{marginBottom: 15}}>{`See `}<Text style={{textDecorationLine: 'underline'}} onPress={() => this.viewReturnPolicy()}>{`${this.state.merchantName}’s website`}</Text> for return policy information</Text>}
        </ScrollView>
      </BaseScreen>
    )
  }
}

const stylesHtml = StyleSheet.create({
  p: {
    fontSize: 14,
    color: Fonts.style.color.baseColor
  },
})

const mapStateToProps = (state) => {
  return {
    item: state.item.item,
    shoppableConfig: state.shoppable.config,
    shoppableItems: state.shoppable.selectedItems,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    readItem: (data) => dispatch(ItemActions.itemRequest(data)),
    shoppableGetConfig: () => dispatch(ShoppableActions.shopGetConfig()),
    shoppableReadItems: (itemIds) => dispatch(ShoppableActions.shopGetItems(itemIds))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDescriptionScreen)
